module.exports = __webpack_public_path__ + "img/swiper_3.0_2_1.8fcc35c2.webp";